import React from 'react';
import PropTypes from 'prop-types';

class Scene extends React.Component {
    render() {
        return <div className="configurator__scene" id="scene3d" />;
    }
}

Scene.propTypes = {};

Scene.defaultProps = {};

export default Scene;
